/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_Card4_SubInputs */

const tr_landing_web_card4_sub = /** @type {(inputs: Landing_Web_Card4_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza kendi alan adınızda yayına girer. KVKK, mesafeli satış ve iade metinleri sizin şirket bilgilerinizle oluşur.`)
};

const en_landing_web_card4_sub = /** @type {(inputs: Landing_Web_Card4_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The store goes live on your own domain. Privacy, distance selling and return pages are generated with your company details.`)
};

const de_landing_web_card4_sub = /** @type {(inputs: Landing_Web_Card4_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Shop läuft unter Ihrer Domain. Datenschutz, Fernabsatzvertrag und Rückgaberegeln entstehen mit Ihren Firmendaten.`)
};

const ru_landing_web_card4_sub = /** @type {(inputs: Landing_Web_Card4_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазин работает на вашем домене. Страницы о персональных данных, дистанционной продаже и возврате формируются с вашими реквизитами.`)
};

/**
* | output |
* | --- |
* | "The store goes live on your own domain. Privacy, distance selling and return pages are generated with your company details." |
*
* @param {Landing_Web_Card4_SubInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_card4_sub = /** @type {((inputs?: Landing_Web_Card4_SubInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_Card4_SubInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_card4_sub(inputs)
	if (locale === "de") return de_landing_web_card4_sub(inputs)
	if (locale === "ru") return ru_landing_web_card4_sub(inputs)
	return tr_landing_web_card4_sub(inputs)
});